import React from 'react';
import PropTypes from 'prop-types';

const debug = require('../debug/debug')('wc:ResizableText');

class ResizableText extends React.Component {

  static propTypes = {
    minFontSize: PropTypes.number,
    children: PropTypes.string
  }

  static defaultProps = {
    minFontSize: 11
  }

  state = {
    fontSize: undefined
  }

  componentDidMount() {
    this.checkHeight();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.children !== this.props.children || prevState.fontSize !== this.state.fontSize) {
      this.checkHeight();
    }
  }

  checkHeight = () => {
    const { minFontSize } = this.props;
    if (!window.getComputedStyle) {
      debug('Browser does not support the window.getComputedStyle() API. Nothing to do.');
      return;
    }

    const node = this._node;
    const style = window.getComputedStyle(node);
    const expected = parseFloat(style.lineHeight.replace('px'), 10);
    if (isNaN(expected)) {
      debug(`Could not parse style. style.lineHeight=${style.lineHeight}`);
      return;
    }

    let actual = node.getBoundingClientRect().height;
    if (actual <= minFontSize) {
      debug(`Reached min font size ${minFontSize}`);
      return;
    }

    if (actual > expected) {
      const fontSize = Math.max(parseFloat(style.fontSize.replace('px', '')) - 0.5, minFontSize);
      this.setState({ fontSize });
    }
  }

  render() {
    const { fontSize } = this.state;
    return (
      <div name="ResizableText" ref={node => this._node = node} style={{ fontSize }}>
        {this.props.children}
      </div>
    );
  }

}

export default ResizableText;
